module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8WiHE"))).then(() => module.bundle.root('d0iPb'));